module.exports = __webpack_public_path__ + "assets/Mail.66e5e2c4c0e6769c5e55a100b6c4a4bc.svg";